import { useEffect } from "react";
import { Header } from "../components/header";
import { PageLoadingShimmer } from "../components/page-loading";
import { Footer } from "../components/footer";
import { useNavigate, useParams } from "react-router-dom";
import useBlogPosts from "../hooks/useBlogPosts";
import moment from "moment";
import { toast } from "react-toastify";

function getAuthorInitials(name) {
  if (!name) return "?";
  return name
    .split(" ")
    .map((part) => part[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
}

export function BlogDetail() {
  const navigate = useNavigate();
  const { id } = useParams();
  const { filteredBlogPost, pageLoading } = useBlogPosts({ postId: id });

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  const handleShare = () => {
    window.navigator.clipboard.writeText(window.location.href);
    toast.success("Copied Link!");
  };

  return (
    <div className='blog-details-container'>
      <Header />
      {pageLoading ? (
        <PageLoadingShimmer />
      ) : filteredBlogPost?.id ? (
        <article className='blog-detail'>
          <div className='blog-detail__hero'>
            <img
              src={filteredBlogPost.blogImage}
              alt={filteredBlogPost.title}
              className='blog-detail__hero-image'
            />
            <div className='blog-detail__hero-overlay'>
              {filteredBlogPost.category ? (
                <span className='blog-detail__category'>
                  {filteredBlogPost.category}
                </span>
              ) : null}
              <h1>{filteredBlogPost.title}</h1>
              <p>{filteredBlogPost.shortDescription}</p>
            </div>
          </div>

          <div className='blog-detail__content'>
            <div className='blog-detail__meta-bar'>
              <div className='blog-detail__author'>
                <span className='blog-detail__avatar'>
                  {getAuthorInitials(filteredBlogPost.author)}
                </span>
                <div>
                  <strong>{filteredBlogPost.author}</strong>
                  <span>
                    {moment(filteredBlogPost.createdAt).format("MMM D, YYYY")} ·{" "}
                    {filteredBlogPost.time} min read
                  </span>
                </div>
              </div>
              <button
                type='button'
                className='blog-detail__share'
                onClick={handleShare}
              >
                <i className='bi bi-share'></i>
                Share
              </button>
            </div>

            <div className='blog-detail__body'>{filteredBlogPost.blogDetails}</div>

            <button
              type='button'
              className='blog-detail__back'
              onClick={() => navigate("/blog")}
            >
              <i className='bi bi-arrow-left'></i>
              Back to Articles
            </button>
          </div>
        </article>
      ) : (
        <div className='blog-detail__not-found'>
          <h2>Article not found</h2>
          <p>The article you are looking for may have been moved or removed.</p>
          <button type='button' onClick={() => navigate("/blog")}>
            Back to Articles
          </button>
        </div>
      )}
      <Footer />
    </div>
  );
}
